import { FC } from 'react'
import { useTranslation } from 'react-i18next';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuestion } from 'store/quiz/quizSelectors';
import { selectQuestionReady } from 'store/player/playerSelectors';
import QuestionTypes from 'types/QuestionTypes';
import IQuestion from 'models/Question';

const Question:FC = () => {
  const { t } = useTranslation();

  const question:IQuestion = useAppSelector(selectQuestion);
  const questionReady:boolean = useAppSelector(selectQuestionReady);

  if ( !questionReady && !question.video && !question.audio ) return null;
  return (
    <div className="py-2 px-4">
      <p className="text-xl text-primary font-bold text-center">
        {question.title}
        {question.type === QuestionTypes.MultiChoice ? (
          <span className="block text-xs text-primary">
            {`( ${t('pages.question.multiChoiceHint')} )`}
          </span>
        ) : null}
      </p>
    </div>
  )
}

export default Question;
